module.exports = __webpack_public_path__ + "img/rebot_4.01fa1bca.png";